<!--
 * @Author: 汪俊洪
 * @Date: 2022-04-13 10:34:21
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-04-30 16:15:34
 * @Description: 导出模板
-->
<template>
  <div class="dialog-wrap">
    <el-button class="history-btn plc-btn" size="small" @click="showDialog"
      >导出历史</el-button
    >
    <!-- 批量导出历史 -->
    <el-dialog
      title="批量导出历史"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <Search
        ref="search"
        :searchConfig="tableConfigExport"
        @doSearch="doSearch"
      >
      </Search>
      <!-- 列表 -->
      <Table
        ref="tableExport"
        class="table-wrap plc-table"
        :tableConfig="tableConfigExport"
      >
        <template :slot="'templateCode'" slot-scope="scope">
          {{ scope.row.templateName }}
        </template>
        <template :slot="'statusIn'" slot-scope="scope">
          {{ scope.row.status | getStatus }}
        </template>
        <template :slot="'exportProgress'" slot-scope="scope">
          {{ getProgress(scope.row) }}
        </template>
        <template :slot="'result'" slot-scope="scope">
          <el-button
            type="text"
            @click="() => showResult(scope.row)"
            v-if="scope.row.status === '3'"
            >查看结果</el-button
          >
          <span v-else> {{ scope.row.status === '2' ? '成功' : '-' }} </span>
        </template>
        <template :slot="'downloadUrl'" slot-scope="scope">
          <el-link
            type="success"
            v-if="scope.row.downloadUrl"
            :href="scope.row.downloadUrl"
            target="_blank"
            >下载</el-link
          >
          <el-button
            type="text"
            @click="() => cancel(scope.row)"
            v-if="scope.row.status === '0' || scope.row.status === '1'"
            >取消</el-button
          >
        </template>
      </Table>
    </el-dialog>
    <el-dialog
      title="错误信息"
      :visible.sync="errorDialogVisible"
      width="1000px"
      append-to-body
    >
      <pre style="white-space: pre-wrap; max-height: 500px; overflow: auto">{{
        errorInfo
      }}</pre>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="errorDialogVisible = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Search from './search.vue'
import Table from '@/components/table/index'
import { shortcuts } from '@/utils/shortcuts'
import { mul } from '@/utils/numberComputed'
const options = [
  {
    value: '等待中',
    code: '0'
  },
  {
    value: '进行中',
    code: '1'
  },
  {
    value: '成功',
    code: '2'
  },
  {
    value: '失败',
    code: '3'
  },
  {
    value: '已取消',
    code: '4'
  }
]

export default {
  props: {
    templateCodeIn: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    setPermission: {
      type: Function,
      default: null
    },
    // 第三方对接模式的导出历史
    isThirdParty: {
      type: Boolean,
      default: false
    },
    templateCodeList: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    getStatus (val) {
      let str = ''
      options.some((v) => {
        if (v.code === val) {
          str = v.value
          return true
        }
        return false
      })
      return str || val
    }
  },
  components: {
    Table,
    Search
  },
  data () {
    return {
      dialogVisible: false,
      errorDialogVisible: false,
      errorInfo: '',
      tableConfigExport: {
        searchUrl: '/help/export-log-mgmt/v1/sys-exports/my', // 搜索接口
        searchMethod: 'GET', // 接口请求方式
        autoSearch: false, // 是否需要默认查询
        searchType: 'restful', // 搜索类型
        needPagination: true, // 是否需要分页
        resultListName: 'dataList',
        hideLabel: true, // 搜索隐藏label
        maxHeight: '400px',
        params: [
          {
            prop: 'templateCode',
            label: '导出类型',
            width: '136px',
            placeholder: '导出类型',
            searchType: 'tabSelect',
            props: {
              label: 'value',
              value: 'code'
            },
            isSlot: true,
            options: []
          },
          {
            prop: 'statusIn',
            label: '任务状态',
            searchType: 'multipleSelect',
            placeholder: '任务状态',
            isSlot: true,
            props: {
              label: 'value',
              value: 'code'
            },
            options
          },
          {
            prop: 'createTime',
            label: '任务提交时间',
            width: '135px',
            columnsType: 'date',
            sortable: true,
            searchType: 'datetimerange',
            props: ['createTimeSt', 'createTimeEd'],
            pickerOptions: {
              shortcuts
            }
          },
          {
            prop: 'startTime',
            label: '任务执行时间',
            width: '135px',
            hideInSearch: true
          },
          {
            prop: 'endTime',
            label: '任务完成时间',
            width: '135px',
            hideInSearch: true
          },
          {
            prop: 'exportProgress',
            label: '任务进度',
            isSlot: true,
            hideInSearch: true
          },
          {
            prop: 'result',
            label: '结果信息',
            hideInSearch: true,
            isSlot: true
          },
          {
            prop: 'downloadUrl',
            label: '操作',
            hideInSearch: true,
            isSlot: true
          }
        ],
        extra: {
          // 额外参数
          templateCodeIn: this.templateCodeIn
        }
      },
      extra: {},
      templateCode: []
    }
  },
  created () {
    if (this.url) {
      this.tableConfigExport.searchUrl = this.url
    }
  },
  mounted () {
    console.log('isThirdParty')
    if (this.isThirdParty) {
      this.setThirdPartyData()
    } else {
      this.setData()
    }
    // 如果是老逻辑
    if (this.templateCodeIn) {
      this.setData()
    }
    // 20231213新增显示逻辑
    if (
      this.templateCodeList instanceof Array &&
      this.templateCodeList.length
    ) {
      this.templateCode = this.templateCodeList.map((v) => v.code)
      this.tableConfigExport.params[0].options = this.templateCodeList
      this.tableConfigExport.extra.templateCodeIn = this.templateCode.join(',')
    }
  },
  methods: {
    // 获取任务进度
    getProgress (row) {
      switch (row.status) {
        case '0':
        case '3':
          return '-'
        case '1':
          return mul(row.exportProgress || 0, 100).toFixed(2) + '%'
        case '2':
          return '100%'
        default:
          return '-'
      }
    },
    // 查看导出历史
    showDialog () {
      this.dialogVisible = true
      setTimeout(() => {
        this.doSearch()
      }, 100)
    },
    // 查看结果
    showResult (row) {
      this.$http
        .get(`/help/export-log-mgmt/v1/sys-exports/${row.id}/exception-stack`)
        .then(({ data: res }) => {
          console.log(res)
          this.errorInfo = res.data
          this.errorDialogVisible = true
        })
    },
    // 查询
    doSearch (input) {
      if (input) {
        this.tableConfigExport.extra = {
          ...input,
          templateCodeIn: this.templateCode.join(',')
        }
      }
      // 第三方导出历史 不需要从字典取值
      if (this.isThirdParty) {
        this.tableConfigExport.extra.templateCodeIn = this.templateCodeIn
      }
      this.tableConfigExport.extra = {
        ...this.tableConfigExport.extra,
        ...this.extra
      }
      this.$refs.tableExport.clearSort()
      this.$refs.tableExport.getList()
    },
    // 第三方导出历史 不需要注册字典 没有顶部tab筛选 增加操作人
    setThirdPartyData () {
      console.log('setThirdPartyData')
      this.tableConfigExport.params[0].searchType = ''
      this.tableConfigExport.params[0].hideInSearch = true

      const actionItem = this.tableConfigExport.params.pop()
      this.tableConfigExport.params.push(
        ...[
          {
            prop: 'createUserName',
            label: '操作人',
            placeholder: '操作人'
          },
          actionItem
        ]
      )
      this.tableConfigExport.extra.templateCodeIn = this.templateCodeIn
    },
    setData () {
      const dictList = window.SITE_CONFIG.dictList.SYS_EXPORT_TYPE // 获取字典
      let value = ''
      dictList.some((v) => {
        if (v.code === this.templateCodeIn) {
          value = v.value
          return true
        }
        return false
      })
      let arr = value.split(',').map((v) => {
        const o = v.split(':')
        return {
          code: o[0],
          value: o[1]
        }
      })
      if (typeof this.setPermission === 'function') {
        arr = this.setPermission(arr)
      }
      this.templateCode = arr.map((v) => v.code)
      this.tableConfigExport.params[0].options = arr
      this.tableConfigExport.extra.templateCodeIn = this.templateCode.join(',')
    },
    cancel (row) {
      this.$http
        .post(`/help/export-log-mgmt/v1/cancel-export?logId=${row.id}`, {
          logId: row.id
        })
        .then(({ data: res }) => {
          this.$message.success('操作成功')
          const dataForm = {
            ...this.$refs.search.getParams()
          } // 获取筛选条件
          this.doSearch(dataForm)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  display: inline-block;

  .history-btn {
    margin-left: 6px;
  }
}
</style>
